export const HIRE_FROM_CRIO_LSQ_HOST =
  'https://lsq-proxy.prod.crio.do/lsq/b2b/v2';
